<script setup lang="ts">
const { user, color = 'primary' } = defineProps<{ user: User, color?: string}>()
</script>
<template>
  <div class="d-flex align-center">
    <Avatar
      :size="32"
      :name="user.name"
      :src="user.avatar_url"
      :color="color"
    />
    <nuxt-link
      v-if="!user.claimable"
      :to="`/profiles/${user.slug}-${user.id}`"
      class="mx-3"
    >
      {{ user.name }}
    </nuxt-link>
    <span v-else class="mx-3">{{ user.name }}</span>
    <v-img
      v-if="user.national_association_details?.iso3166"
      :src="`/flags/${user.national_association_details.iso3166.toLowerCase()}.svg`"
      width="25"
      min-width="25"
      max-width="25"
      contain
    />
  </div>
</template>
